"use client";
import React from "react";

import type { ChainSegmentParams, ParamProps } from "@/app/types";
import Space from "@/components/common/space";
import { GlobalWrapper, Wrapper } from "@/components/common/wrapper.styled";
import Earn from "@/components/earn/earn";
import { EarnTitle } from "@/components/earn/earn-title";
import { useWeb3Context } from "@/contexts/web3";
import { useMarginlyApi } from "@/hooks/api";

export default function EarnPage(props: ParamProps<ChainSegmentParams>) {
  const { internalChainId } = useWeb3Context();

  const { data } = useMarginlyApi({
    endpoint: "earnInfo",
    args: [internalChainId],
  });

  return (
    <GlobalWrapper>
      <Wrapper className="earn">
        <EarnTitle
          chain={props.params.chain}
          // lenders={data?.lenders}
          // totalLiquidityUsd={data?.totalLiquidityUsd}
          // traders={data?.traders}
          // volumeTodayUsd={data?.volumeTodayUsd}
        />
        {/* 
        <Space
          height={props.params.chain === "blast" ? 32 : 58}
          heightMobile={26}
        /> */}

        <Earn chain={props.params.chain} tokenInfoList={data?.tokens} />
      </Wrapper>
      <Space height={48} heightMobile={74} />
    </GlobalWrapper>
  );
}
